import React, { useState, useEffect,useRef } from "react";
import { useSelector,useDispatch } from "react-redux";
import { Header, Input, Form, Button,Label } from "semantic-ui-react";
import { Formik, Field, Form as FormikForm } from "formik";
import {FormikInputComponent} from "../../../utilities/formUtils";


const Signup_Step_Four = (props) => {
    const onchangehandle = () =>{
        props.setotpErrorclass("");
        props.setcustomOtpErrorMsg("");
    }
    return(
        <div style={{display :props.displayparam}}>
            <div className="sign-up-head">
                <h3 className="signuptxt">One-Time Password Verification</h3>
            </div>
            <div className="sign-up-form-info">
                <form>
                    <div className="mb-3">
                        <label for="Inputemail" className="sign-up-field-name form-label">Verification Code</label>
                        <Field
                            id="otp"
                            name="otp"
                            noLabel="y"
                            component={FormikInputComponent}
                            icontoShow = 'key'
                            iconPosition='left'
                            placeholder = "Enter your OTP"
                            style={{marginTop:"11px"}}
                            className={props.otpErrorclass}
                            myChangeFunction = {onchangehandle}
                            iserror={props.otpErrorclass != "" ? true : false}
                            customErrorMsg = {props.customOtpErrorMsg}
                            />
                        <div className="otp-info">OTP has been sent to ********k876@gmail.com</div>
                    </div>
                    <div className="otp-info beforeButtonTextSmallTop">Didn't receive the OTP? <a>Resend</a></div>
                </form>
            </div>
        </div>
    )
}
export default Signup_Step_Four;